export enum FileAttachmentTypeEnum {
  TABLE = 'table',
  DOCUMENT = 'document',
  IMAGE = 'image',
  ARCHIVE = 'archive',
  PDF = 'pdf',
  TEXT = 'text',
}
